// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"020189ca","455":"bd97a85a","977":"682a4c9d"}[chunkId] + ".chunk.js";
};